import {
  statementOptions,
  selectStatement,
  statementSelectionSchema,
  type Field,
  type Project,
  type Values,
} from "@proof/core";

export function StatementPicker({
  project,
  field,
  value,
  disabled,
  onChange,
}: {
  project?: Project;
  field: Field;
  value: Values[string];
  disabled: boolean;
  onChange: (value: Values[string]) => void;
}) {
  let options;
  try {
    options =
      project && field.source.datasetId
        ? statementOptions(project, field)
        : undefined;
  } catch {
    options = undefined;
  }
  const selected = statementSelectionSchema.safeParse(value);
  return (
    <fieldset
      className="statement-picker"
      style={{ border: 0, padding: 0, margin: "0 0 10px" }}
    >
      <legend>Reusable statements</legend>
      {!options ? (
        <p role="status">
          Statement content is unavailable. Configure a statement group or enter
          custom text.
        </p>
      ) : (
        <label>
          Statement for {field.label}
          <select
            aria-label={`Statement for ${field.label}`}
            disabled={disabled}
            value={
              selected.success &&
              selected.data.statement.datasetId === field.source.datasetId &&
              selected.data.statement.datasetVersion ===
                field.source.datasetVersion
                ? selected.data.statement.statementId
                : ""
            }
            onChange={(event) =>
              onChange(
                event.target.value
                  ? selectStatement(project!, field, event.target.value)
                  : "",
              )
            }
          >
            <option value="">Custom text / no statement</option>
            {options.map((option) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      )}
      {selected.success && (
        <button
          type="button"
          onClick={() => {
            const url = URL.createObjectURL(
                new Blob([JSON.stringify(selected.data)], {
                  type: "application/json",
                }),
              ),
              anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = `${field.id}-statement-selection.json`;
            anchor.click();
            setTimeout(() => URL.revokeObjectURL(url), 0);
          }}
        >
          Download statement selection
        </button>
      )}
      <small className="field-help">
        Choosing a statement fills the field below. Editing the text makes it
        custom content.
      </small>
    </fieldset>
  );
}
